import React from 'react';
import './LoadingOverlay.css';

export default function LoadingOverlay({ isLoading, message = 'جاري المعالجة...' }) {
    if (!isLoading) return null;

    return (
        <div className="loading-overlay-root">
            <div className="loading-spinner-container">
                <div className="spinner"></div>
                <div className="loading-message">{message} <br /> يرجى عدم إغلاق المتصفح قبل انتهاء العملية  </div>
            </div>
        </div>
    );
}
